module.exports = __webpack_public_path__ + "img/13.b874751.png";